import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Vant from 'vant'
import 'vant/lib/index.css'
import { addCollection } from '@iconify/vue'
import App from './App.vue'
import router from './router'
import './assets/styles/main.scss'

// 覆盖 Vant4 默认主题变量（现代简约老钱风）
import './assets/styles/vant-override.scss'

// 本地离线加载 solar 图标集，避免运行时向 api.unisvg.com 网络请求导致图标加载失败
// 项目中共用到 200+ 个 solar 图标，离线注册后完全无网络依赖
import solarIcons from '@iconify-json/solar/icons.json'
import { localIcons } from './assets/icons/local'

addCollection(solarIcons)
// 项目自绘图标（aries 前缀）：花瓣流水等 solar 集里没有的场景图标
addCollection(localIcons)

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(Vant)

// 全局错误捕获：捕获 Vue 组件渲染/生命周期中未被 try-catch 的异常
// 保留作为生产期错误兜底，避免静默故障
app.config.errorHandler = (err, instance, info) => {
  const tag = instance?.$?.type?.name || instance?.$?.type?.__name || 'Anonymous'
  // eslint-disable-next-line no-console
  console.error('[Vue Error]', tag, info, err)
}

app.mount('#app')
